import React from 'react';
import ButtonComponent from 'src/components/ButtonComponent';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';

import LoadingIcon from 'src/frontend-common/components/Icons/Loading';
import FailureScreen from 'src/frontend-common/components/FailureScreen';
import { GetCompanyFromEmailResponse } from 'src/dto/SuperAdmin';
import Row from 'src/frontend-common/components/Row';

export interface CompanyFromEmailProps {
  email: string;
  setEmail: (email: string) => void;
  emailData: GetCompanyFromEmailResponse | undefined;
  emailIsLoading: boolean;
  emailIsError: boolean;
  setSendRequestEmail: (sendRequestEmail: boolean) => void;
}

const CompanyFromEmail: React.FC<CompanyFromEmailProps> = ({ email, setEmail, emailData, emailIsLoading, emailIsError, setSendRequestEmail }) => {
  const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSendRequestEmail(false);
    if (event.target.value && event.target.value.trim().length > 0) {
      setEmail(event.target.value);
    }
  };
  return (
    <>
      <Row style={{ alignItems: 'flex-end', justifyContent: 'space-between' }}>
        <TextField
          id="email"
          style={{ width: '80%' }}
          inputProps={{ style: { width: '100%' } }}
          onChange={handleChangeEmail}
          placeholder="user@email.com"
          label="Email"
          value={email}
        />
        <ButtonComponent
          buttontype="mainaction"
          style={{ float: 'right' }}
          text="SEARCH"
          data-testid="save-button"
          onClick={() => setSendRequestEmail(true)}
          disabled={email.trim().length === 0}
        />
      </Row>

      {emailIsLoading && (
        <div style={{ textAlign: 'center', paddingTop: '100px' }}>
          <LoadingIcon />
        </div>
      )}

      {!emailIsLoading && emailIsError && (
        <div style={{ textAlign: 'center', paddingTop: '100px' }}>
          <FailureScreen testId="error-company-fetch">An error occurred while fetching the user data. Please try to refresh the page.</FailureScreen>
        </div>
      )}
      {!emailIsLoading && !emailIsError && emailData && (
        <TableContainer component={Paper} style={{ marginTop: 16 }}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Company ID</TableCell>
                <TableCell align="right">Company Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {[emailData].map((row) => (
                <TableRow
                  key={row.company_id}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {row.company_id}
                  </TableCell>
                  <TableCell align="right">{row.company_name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};

export default CompanyFromEmail;
